// services/bindings.js
import api from './api';

export const getProxyBindings = async (proxyId) => {
  const response = await api.get(`/proxies/${proxyId}/bindings`);
  return response.data;
};

export const getTokenBindings = async (tokenId) => {
  const response = await api.get(`/tokens/${tokenId}/bindings`);
  return response.data;
};